import { useState, useCallback } from "react";
import { login as apiLogin } from "@/api/admin.api";

export function useAuth() {
  const [token, setToken] = useState<string | null>(
    () => localStorage.getItem("admin_token")
  );

  const isAuthenticated = !!token;

  const login = useCallback(async (email: string, password: string) => {
    const { token: newToken } = await apiLogin(email, password);
    localStorage.setItem("admin_token", newToken);
    setToken(newToken);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("admin_token");
    setToken(null);
  }, []);

  return { isAuthenticated, token, login, logout };
}
